import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { CUSTOMIZER_ONLY } from "./config";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProductSection from "./components/ProductSection";
import CategorySections from "./components/CategorySections";
import NewArrivalsSpotlight from "./components/NewArrivalsSpotlight";
import About from "./components/About";
import Resources from "./components/Resources";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ShoppingCart from "./components/ShoppingCart";
import CustomizerPage from "./components/CustomizerPage";
import SubmissionsPage from "./components/SubmissionsPage";
import AdminPage from "./components/AdminPage";
import AdminGuard from "./components/AdminGuard";
import ToucheCollab from "./components/ToucheCollab";
import HowItWorks from "./components/HowItWorks";
import LookOfTheWeek from "./components/LookOfTheWeek";
import OccasionsGuide from "./components/OccasionsGuide";
import Testimonials from "./components/Testimonials";
import ConnectStrip from "./components/ConnectStrip";

// Main website component
const MainWebsite = ({ onNavigate }) => {
  return (
    <>
      <Navbar onNavigate={onNavigate} />
      <main>
        <Hero onNavigate={onNavigate} />
        <NewArrivalsSpotlight />
        <About />
        <HowItWorks />
        <LookOfTheWeek />
        <CategorySections />
        <ProductSection
          category="new-arrivals"
          title="New Arrivals"
          description="Discover our latest additions to the collection"
        />
        <ProductSection
          category="best-sellers"
          title="Best Sellers"
          description="Our most loved pieces, chosen by our customers"
        />
        <OccasionsGuide />
        <ToucheCollab />
        <Testimonials />
        <Resources />
        <ConnectStrip />
        <Contact />
      </main>
      <Footer onNavigate={onNavigate} />
      <ShoppingCart />
    </>
  );
};

function App() {
  const handleNavigate = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else if (section === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <CartProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-white">
          <Routes>
            {CUSTOMIZER_ONLY ? (
              <>
                <Route path="/" element={<CustomizerPage />} />
                <Route path="/customize" element={<CustomizerPage />} />
                <Route path="/submissions" element={<AdminGuard><SubmissionsPage /></AdminGuard>} />
                <Route path="/admin" element={<AdminGuard><AdminPage /></AdminGuard>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            ) : (
              <>
                <Route path="/" element={<MainWebsite onNavigate={handleNavigate} />} />
                <Route path="/customize" element={<CustomizerPage />} />
                <Route path="/submissions" element={<AdminGuard><SubmissionsPage /></AdminGuard>} />
                <Route path="/admin" element={<AdminGuard><AdminPage /></AdminGuard>} />
              </>
            )}
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
